import { Injectable, signal } from '@angular/core';

import { AccessDeniedPayload } from './auth.types';

/**
 * Surface for "the API just told us the user has no active access".
 *
 * Components subscribe to the `blocked` signal to render the
 * "Suscripcion expirada" modal. The auth HTTP interceptor sets it.
 */
@Injectable({ providedIn: 'root' })
export class SubscriptionGateService {
  readonly blocked = signal<AccessDeniedPayload | null>(null);

  notifyBlocked(payload: AccessDeniedPayload | undefined): void {
    this.blocked.set(
      payload ?? {
        message: 'Suscripcion requerida.',
        reason: 'subscription_inactive',
        portal_url: '',
      },
    );
  }

  dismiss(): void {
    this.blocked.set(null);
  }
}
